module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/settings/settings.component.css
// module id = ./src/app/components/settings/settings.component.css
// module chunks = main